import { useToken } from "native-base";

export { useToken };

export const useColor = (...colorTokens) => useToken("colors", [ ...colorTokens ]);